// Locale helpers for organization registration. Kept in sync with backend
// `Organization::SUPPORTED_LOCALES` (app/models/organization.rb).
export const SUPPORTED_LOCALES = ['en', 'pt-BR', 'pt-PT', 'de', 'pl'] as const;
export type SupportedLocale = typeof SUPPORTED_LOCALES[number];

// Map navigator.language → supported locale. Falls back to 'en' for unknown.
export const getBrowserLocale = (
  browserLang: string = (typeof navigator !== 'undefined' && navigator.language) || 'en'
): SupportedLocale => {
  if (browserLang.startsWith('pt-PT') || browserLang === 'pt-PT') return 'pt-PT';
  if (browserLang.startsWith('pt')) return 'pt-BR';
  if (browserLang.startsWith('de')) return 'de';
  if (browserLang.startsWith('pl')) return 'pl';
  return 'en';
};

// Pick the locale to send to the backend at registration time: prefer the
// active i18n language when supported, otherwise derive from the browser.
export const pickRegistrationLocale = (
  i18nLanguage: string | undefined,
  browserLang?: string
): SupportedLocale => {
  if (i18nLanguage && (SUPPORTED_LOCALES as readonly string[]).includes(i18nLanguage)) {
    return i18nLanguage as SupportedLocale;
  }
  return getBrowserLocale(browserLang);
};
